<div class="card hs-main-panel h-100 overflow-hidden" style="margin-top: 0 !important;"
    [hidden]="(isVisible$ | async) === false" *ngIf="{layman: hsCommonLaymanService.layman$ | async } as ctx">
    <div class="hs-compositions-header">
        <hs-panel-header name="composition_browser" [title]="'PANEL_HEADER.COMPOSITIONS' | translateHs">
            <extra-buttons class="d-flex align-items-center">
                <button class="but-title-sm hs-extra-buttons" (click)="reload()"
                    [title]="'COMMON.reload' | translateHs">
                    <i class="glyphicon icon-fatredo"></i>
                </button>
                <button class="but-title-sm hs-extra-buttons" [title]="'PANEL_HEADER.SAVECOMPOSITION'|translateHs"
                    (click)="openSaveMapPanel()"
                    [hidden]="!saveMapAvailable()"><!-- TODO: Remove function call from template -->
                    <span class="icon-save-floppy"></span>
                </button>
                <label class="but-title-sm hs-extra-buttons btn-file mb-0" style="padding: 1px 6px;"
                    [title]="'COMPOSITIONS.import' | translateHs">
                    <span class="icon-upload"></span><input type="file" (change)="handleFileSelect($event)"
                        accept=".json" style="display: none;">
                </label>
                <button class="but-title-sm hs-extra-buttons" [title]="'COMPOSITIONS.addByAddress'|translateHs"
                    (click)="changeUrlButtonVisible()">
                    <span class="icon-plus"></span>
                </button>
            </extra-buttons>
        </hs-panel-header>
        <div class="mt-3 mx-3 ps-1 d-flex justify-content-between">
            <div class="input-group mb-2" [hidden]="!addCompositionUrlVisible">
                <input type="text" class="form-control" [placeholder]="'COMPOSITIONS.Address'|translateHs"
                    [(ngModel)]="urlToAdd" [ngModelOptions]="{standalone: true}">
                <button type="button" class="btn btn-secondary" (click)="addCompositionUrl(urlToAdd)"><i
                        class="icon-link"></i></button>
            </div>
        </div>
        <div class="mx-3 ps-1 d-flex justify-content-between">
            <div class="input-group" style="width: 55% !important;">
                <input type="search" class="form-control border-end-0" [placeholder]="'COMMON.search'|translateHs"
                    name="search" [(ngModel)]="hsCompositionsCatalogueService.data.query.title"
                    (ngModelChange)="loadFilteredCompositions()">
                <button class="input-group-text text-secondary border-start-0" (click)="loadFilteredCompositions()">
                    <i class="icon-search icon-primary"></i>
                </button>
            </div>
            <hs-layman-current-user [endpoint]="ctx.layman"><!-- TODO: Remove function call from template -->
            </hs-layman-current-user>
        </div>
        <div class="d-flex ms-4 me-3 justify-content-between py-1 ">
            <div class="d-flex">
                <div class="input-group-text border-0">
                    <input type="checkbox" class="checkbox-lg"
                        [(ngModel)]="hsCompositionsCatalogueService.filterByExtent"
                        (change)='loadFilteredCompositions()' name="hsCompositionsCatalogueService.filterByExtent">
                    <span class="ms-1">{{'COMPOSITIONS.filterByMap' | translateHs }}</span>
                </div>
                <div class="input-group-text border-0 ms-1" *ngIf="ctx.layman?.authenticated">
                    <!-- TODO: Remove function call from template -->
                    <input type="checkbox" [(ngModel)]="hsCompositionsCatalogueService.filterByOnlyMine"
                        (change)='loadFilteredCompositions()' name="hsCompositionsCatalogueService.filterByOnlyMine">
                    <span class="ms-1">{{'COMPOSITIONS.onlyMine' | translateHs }}</span>
                </div>
            </div>
            <div ngbDropdown display="dynamic" placement="bottom-right" class="d-inline-block">
                <button class="btn btn-light hs-white-background hs-custom-toggle" (click)="openOptionsMenu()"
                    ngbDropdownToggle>{{translateString('COMMON',
                    optionsButtonLabel)}}</button><!-- TODO: Remove function call from template -->
                <div ngbDropdownMenu class="dropdown-menu-right p-2 m-1"
                    style="min-width: 23rem; max-width: 23rem;  overflow: visible" aria-labelledby="filtersDropdown">
                    <table class="p-1 ps-3" style="border-collapse:separate; border-spacing:0.5rem 0.5rem;">
                        <tbody>
                            <!-- <tr>
                                        <td class="tdbreak">
                                            {{'COMMON.type' | translateHs }}
                                        </td>
                                        <td>
                                            <select class="form-control hs-background-alfa ps-1" name="type"
                                                [(ngModel)]="hsCompositionsCatalogueService.data.type"
                                                (change)="loadFilteredCompositions()"
                                                style="min-width: 11rem; max-width: 11rem;border:0px">
                                                <option *ngFor="let type of hsCompositionsCatalogueService.types"
                                                    [ngValue]="type.value">
                                                    {{translateString('COMPOSITONTYPES', type.name)}}</option>
                                            </select>
                                        </td>
                                    </tr> -->
                            <tr>
                                <td class="tdbreak">
                                    {{'COMMON.keywords' | translateHs }}
                                </td>
                                <td ngbDropdown display="dynamic" placement="bottom-right">
                                    <button type="button" ngbDropdownToggle
                                        class="btn btn-light btn-sm hs-custom-toggle hs-background-alfa p-2 ps-1 border-0"
                                        style="text-align:start; min-width: 11rem; max-width: 11rem; border-radius: 0px; justify-content: space-between; display:flex; align-items: center;">
                                        {{'COMPOSITIONS.selectKeywords' | translateHs }}
                                    </button>
                                    <ul ngbDropdownMenu aria-labelledby="keywords" class="ps-2"
                                        style="overflow-y: auto; max-height: 10rem; min-width: 15rem">
                                        <li *ngFor="let keyword of hsCompositionsCatalogueService.data.keywords, let index = index;"
                                            class="p-1 p-md-0">
                                            <label style="cursor: pointer;"><input class="me-2" type="checkbox"
                                                    [(ngModel)]="keyword.selected" name="keyword[index]"
                                                    (change)="loadFilteredCompositions()">{{translateString('COMPOSITONKEYWORDS',
                                                keyword.name)}}</label>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td class="tdbreak">
                                    {{'COMPOSITIONS.inspireTheme' | translateHs }}
                                </td>
                                <td ngbDropdown display="dynamic" placement="bottom-right">
                                    <button type="button" ngbDropdownToggle
                                        class="btn btn-light btn-sm hs-custom-toggle hs-background-alfa p-2 ps-1 border-0"
                                        style="text-align:start; min-width: 11rem; max-width: 11rem; border-radius: 0px; justify-content: space-between; display:flex; align-items: center;">
                                        {{'COMPOSITIONS.selectThemes' | translateHs }}
                                    </button>
                                    <ul ngbDropdownMenu aria-labelledby="inspireThemes" class="ps-2"
                                        style="overflow-y: auto; max-height: 10rem; min-width: 20rem">
                                        <li *ngFor="let theme of hsCompositionsCatalogueService.data.themes, let index = index;"
                                            class="p-1 p-md-0">
                                            <label style="cursor: pointer;"><input class="me-2" type="checkbox"
                                                    [(ngModel)]="theme.selected" name="theme[index]"
                                                    (change)="loadFilteredCompositions()">{{translateString('COMPOSITONINSPIRETHEMES',
                                                theme.name)}}</label>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td class="tdbreak">
                                    {{'COMMON.sortBy' | translateHs }}
                                </td>
                                <td ngbDropdown display="dynamic" placement="bottom-right" #sortByDrop="ngbDropdown">
                                    <button type="button" ngbDropdownToggle
                                        class="btn btn-light btn-sm hs-custom-toggle hs-background-alfa p-2 ps-1 border-0"
                                        style="text-align:start; min-width: 11rem; max-width: 11rem; border-radius: 0px; justify-content: space-between; display:flex; align-items: center;">
                                        {{translateString('COMPOSITONSORTVALUES',
                                        hsCompositionsCatalogueService.data.sortBy.name)}}
                                    </button>
                                    <ul ngbDropdownMenu aria-labelledby="sortBy" class="ps-2"
                                        style="overflow-y: auto; max-height: 10rem; min-width:10rem">
                                        <li *ngFor="let item of hsCompositionsCatalogueService.sortByValues, let index = index;"
                                            class="p-2 p-md-0">
                                            <label style="cursor: pointer;"><input class="me-2" type="radio"
                                                    name="sort-index" [checked]="(index === 0)"
                                                    (change)="sortByValueChanged(item);sortByDrop.close()">{{translateString('COMPOSITONSORTVALUES',
                                                item.name)}}</label>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2" style="text-align: center; vertical-align: middle;">
                                    <button class="btn w-100 btn-light hs-background-alfa"
                                        style="border-radius: 0.25rem;" (click)="clearFilters()">
                                        {{'COMPOSITIONS.clearFilters' | translateHs }}</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="card d-flex flex-fill border-bottom-0" style="font-size: 1rem !important; overflow-y:auto;     overflow-y: auto;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;">
        <div class="card-body border-0">
            <ul class="list-group">
                <li *ngFor="let composition of hsCompositionsCatalogueService.compositionEntries"
                    [hidden]="hsCompositionsCatalogueService.dataLoading" class="list-group-item clearfix"
                    style="cursor: pointer;" [ngClass]="{'hs-endpoint-item-active' : composition.highlighted}"
                    (mouseover)="highlightComposition(composition, true)"
                    (mouseleave)="highlightComposition(composition, false)" (click)="compositionClicked(composition)"
                    data-container="body" data-placement="bottom" [attr.title]="composition.mdAbstract">
                    <hs-compositions-list-item [composition]="composition" [selectedCompId]="selectedCompId">
                    </hs-compositions-list-item>
                </li>
                <li class="list-group-item text-primary text-center py-2"
                    *ngIf="hsCompositionsCatalogueService.dataLoading"><span
                        class="hs-loader hs-loader-dark pe-2"></span>&emsp;{{'COMMON.loading' |
                    translateHs }}</li>
                <li [hidden]="hsCompositionsCatalogueService.compositionEntries.length > 0 || hsCompositionsCatalogueService.dataLoading"
                    class="list-group-item">
                    {{'DATASOURCE_SELECTOR.noResults' | translateHs }}</li>
            </ul>
        </div>
    </div>
    <ng-container
        *ngIf="hsCompositionsCatalogueService.matchedRecords !== 0 && !hsCompositionsCatalogueService.dataLoading">
        <hs-pager class="sticky-bottom bg-white border border-top-0"
            [pagerService]="hsCompositionsCatalogueService"></hs-pager>
    </ng-container>
</div>
